import { createRouter, createWebHistory } from 'vue-router';
import LandingPage from '@/views/LandingPage.vue';
import HomePage from '@/views/HomePage.vue';
import UserSignup from '@/views/UserSignup.vue';
import UserLogin from '@/views/UserLogin.vue';
import UserProfile from '@/views/UserProfile.vue';
import UserFeedback from '@/views/UserFeedback.vue';
import AdminView from '@/views/AdminView.vue';
import OrphanedUsers from '@/views/OrphanedUsers.vue';
import PendingView from '@/views/PendingView.vue';
import ReleaseNotes from '@/views/ReleaseNotes.vue';
import SessionEntry from '@/views/SessionEntry.vue'; 
import TournamentView from '@/views/TournamentView.vue';
import SettingsView from '@/views/SettingsView.vue';
import PlayersView from '@/views/PlayersView.vue';
import TournamentViewReadOnly from '@/views/TournamentViewReadOnly.vue';
import TournamentResultsListView from '@/views/TournamentResultsListView.vue';
import LinkedPlayersResultsView from '@/views/LinkedPlayersResultsView.vue';
import TournamentResultEditView from '@/views/TournamentResultEditView.vue';
import PrivacyPolicy from '@/views/PrivacyPolicy.vue';
import TermsOfService from '@/views/TermsOfService.vue';
import { useUserStore } from '@/stores/users';

const routes = [
  {
    path: '/',
    name: 'LandingPage',
    component: LandingPage
    // No requiresAuth — the component itself redirects authenticated users
  },
  {
    path: '/home',
    name: 'HomePage',
    component: HomePage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/session-entry',
    name: 'SessionEntry',
    component: SessionEntry,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/signup',
    name: 'UserSignup',
    component: UserSignup
  },
  {
    path: '/login',
    name: 'UserLogin',
    component: UserLogin
  },
  {
    path: '/profile/:userId',
    name: 'UserProfile',
    component: UserProfile,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/feedback',
    name: 'UserFeedback',
    component: UserFeedback,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/admin',
    name: 'AdminView',
    component: AdminView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/admin/orphaned-users',
    name: 'OrphanedUsers',
    component: OrphanedUsers,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/release-notes',
    name: 'ReleaseNotes',
    component: ReleaseNotes
  },
  {
    path: '/pending',
    name: 'PendingView',
    component: PendingView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/tournament',
    name: 'TournamentView',
    component: TournamentView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings',
    name: 'SettingsView',
    component: SettingsView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/players',
    name: 'PlayersView',
    component: PlayersView,
    props: route => ({ tournamentName: route.params.tournamentName }), // Pass `tournamentName` as a prop
    meta: {
      requiresAuth: true
    }
  },
    {
    path: '/vt/:id?',
    name: 'TournamentViewReadOnly',
    component: TournamentViewReadOnly,
    props: true
  },
  {
    path: '/leagues',
    name: 'LeagueList',
    component: () => import('@/views/LeagueListView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/leagues/:id',
    name: 'LeagueDetail',
    component: () => import('@/views/LeagueDetailView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/lg/:id',
    name: 'LeagueViewReadOnly',
    component: () => import('@/views/LeagueViewReadOnly.vue'),
  },
  {
    path: '/tournament/results',
    name: 'TournamentResultsList',
    component: TournamentResultsListView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/tournament/linked-results',
    name: 'LinkedPlayersResults',
    component: LinkedPlayersResultsView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/tournament/results/:id/edit',
    name: 'TournamentResultEdit',
    component: TournamentResultEditView,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/terms-of-service',
    name: 'TermsOfService',
    component: TermsOfService,
  }];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach(async (to, from, next) => {  
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth) {
    const userStore = useUserStore();
    // Ensure the auth state is checked before proceeding.
    // This will only run the complex check once.
    await userStore.checkLogin();
    if (!userStore.loggedin) {
      next({ name: 'UserLogin' });
    } else {
      next();
    }
  } else {
    // Otherwise, proceed to the route
    next();
  }
});

export default router;